import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=406a2ebe&scoped=true&"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductsCarousel.vue?vue&type=style&index=1&id=406a2ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406a2ebe",
  null
  
)

export default component.exports